export default function NotFound() {
    return (
        <div>
            ERROR 404 PAGE NOT FOUND!
        </div>
    )
}